var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4949 87.6944C21.9762 95.4577 28.4239 101.904 36.1892 106.385C43.9545 110.866 52.7635 113.223 61.7297 113.219C70.6958 113.223 79.5048 110.866 87.2701 106.385C95.0355 101.904 101.483 95.4577 105.964 87.6944M17.4949 36.6444C21.9762 28.8811 28.4239 22.4347 36.1892 17.9538C43.9545 13.473 52.7635 11.1158 61.7297 11.1194C70.6958 11.1158 79.5048 13.473 87.2701 17.9538C95.0355 22.4347 101.483 28.8811 105.964 36.6444",
    stroke: "#FF813B",
    strokeWidth: 7.66015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8364 112.964C66.8364 112.964 74.0267 103.504 78.5564 87.6943M66.8364 11.3745C66.8364 11.3745 74.0267 20.829 78.5564 36.6443M56.6228 112.964C56.6228 112.964 49.4325 103.51 44.9028 87.6943M56.6228 11.3745C56.6228 11.3745 49.4325 20.829 44.9028 36.6443M46.4093 51.9593L54.0695 77.4843L61.7296 51.9593L69.3898 77.4843L77.0499 51.9593M5.55518 51.9593L13.2153 77.4843L20.8755 51.9593L28.5356 77.4843L36.1958 51.9593M87.2634 51.9593L94.9236 77.4843L102.584 51.9593L110.244 77.4843L117.904 51.9593",
    stroke: "#FF813B",
    strokeWidth: 7.66015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerIcon);
export default __webpack_public_path__ + "static/media/server_icon.61a13c13d7f381df70fa0cca3fd52fac.svg";
export { ForwardRef as ReactComponent };